import { render, staticRenderFns } from "./horarioAtencion.vue?vue&type=template&id=d233e0f0&scoped=true"
import script from "./horarioAtencion.vue?vue&type=script&lang=js"
export * from "./horarioAtencion.vue?vue&type=script&lang=js"
import style0 from "./horarioAtencion.vue?vue&type=style&index=0&id=d233e0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d233e0f0",
  null
  
)

export default component.exports